<template>
    <fieldset :disabled="formDisabled">
        <form class="form form-horizontal" v-on:submit.prevent data-vv-scope="historicArtifact">>
            <div class="form-group">
                <label class="col-md-2 control-label">Component Age(s)</label>
                <div class="col-md-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'significantPeriodList'" :hasAppend="true"></qaqcFormFieldSelect>
                    <ageSelection :isPrehistoric="false" :parentFormName="qaqcFieldId + 'haf'" ref="ageSelection"></ageSelection>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2 control-label">Artifacts</label>
                <div class="col-md-10">
                    <div class="well form-group">
                        <div v-for="category in artifactCategoryList"class="col-md-2">
                            <label>{{category.description}}</label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageDetailsList' + category.artifactCategoryId" :hasAppend="true"></qaqcFormFieldSelect>
                            <ul type="none" style="padding-left:0px">
                                <li v-for="artifact in artifactList.filter(x => {return x.artifactCategoryId === category.artifactCategoryId})">
                                    <div class="checkbox checkbox-inline">
                                        <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + artifact.artifactId + artifact.description" :value="artifact.artifactId">
                                            <label :for="qaqcFieldId + artifact.artifactId + artifact.description">{{ artifact.description}}</label>
                                        </input>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2 control-label">Estimated Total Assemblage Size</label>
                <div class="col-md-3 form-inline">
                    <select class="form-control" v-model="assemblageDto.assemblageSizeId" v-validate="'required'" name="assemblageSize">
                        <option value="">Select a value</option>
                        <option value="1">Less than 10</option>
                        <option value="2">11-100</option>
                        <option value="3">101-1000</option>
                        <option value="4">1001-10000</option>
                        <option value="5">>10000</option>
                        <option value="6">Unknown</option>
                    </select>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageSizeId'" :hasAppend="false"></qaqcFormFieldSelect>
                    <span v-show="errors.has('historicArtifact.assemblageSize')" class="has-error">{{ errors.first('historicArtifact.assemblageSize') }}</span>
                </div>
                <label class="col-md-1 control-label">Keywords</label>
                <div class="col-md-4 form-inline">
                    <input type="text" class="form-control" v-model="assemblageDto.keywords">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'keywords'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2">Diagnostic Artifact Inventory</label>
                <div class="col-md-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'historicArtifactInventoryList'" :hasAppend="true"></qaqcFormFieldSelect>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Artifact Type</th>
                                <th>Collected</th>
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in inventoryList">
                                <td>{{item.artifactType}}</td>
                                <td>{{item.collected ? "Yes" : "No"}}</td>
                                <td><a class="fa fa-ban" style="font-size: 18px;" v-on:click="removeInventory(index)"></a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div  v-if="!(formDisabled)" class="form-group">
                <div class="col-md-1 col-md-offset-10">
                    <button class="form-contol btn" v-on:click="$refs['inventoryModal'].open()">Add Inventory</button>
                </div>
            </div>
            <modal ref="inventoryModal">
                <div slot="header" class="row">
                    <h3 class="pull-left">Artifact Inventory Entry</h3>
                    <button class="btn pull-right" v-on:click="$refs['inventoryModal'].close()">X</button>
                </div>
                <div slot="body">
                    <div class="form form-horizontal">
                        <div class="form-group">
                            <label class="col-md-2 control-label">Artifact Type</label>
                            <div class="col-md-6">
                                <input type="text" class="form-control" v-model="inventoryDto.artifactType">
                            </div>
                            <div class="col-md-4">
                                <div class="checkbox checkbox-inline">
                                    <input :id="qaqcFieldId + 'inventoryCollectedCB'" type="checkbox" v-model="inventoryDto.collected">
                                        <label :for="qaqcFieldId + 'inventoryCollectedCB'">Collected</label>
                                    </input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="footer">
                    <div class="row">
                        <button name="buttonDone" class="btn btn-primary col-md-3" v-on:click="inventoryDone()">Done</button>
                        <button name="buttonMore" class="btn btn-primary col-md-3 pull-right" v-on:click="inventoryMore()">More</button>
                    </div>
                </div>
            </modal>
            <div v-if="!(formDisabled || qaqcEnabled)" class="col-md-2">
                <button class="btn btn-primary pull-right" v-on:click="saveHistoricArtifact">Save</button>
            </div>
            <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'historicArtifact'" :completeSection="completeSection"></qaqcFormFieldFooter>
        </form>
    </fieldset>
</template>

<script>
import checkBoxPanel from '../CheckBoxPanel.vue'
import ageSelection from './ageSelection.vue'
import modal from '../Modal.vue'
import loggingService from '../../services/util/loggingService'
import artifactService from '../../services/lookup/artifactService'
import historicArtifactService from '../../services/siteForm/historicArtifactService'
// import qaqcService from '@/services/qaqcService'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'

export default {
    name: 'historicArtifactForm',
    components: {
        checkBoxPanel,
        modal,
        ageSelection,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            //significantPeriodList: [],
            artifactList: [],
            artifactCategoryList: [],
            selectedList: [],
            inventoryList: [],
            inventoryDto: {},
            assemblageDto: {}
        }
    },
    props: {
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no propertyDescription qa/qc object, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.historicArtifact) {
                //     this.qaqcProgressDto.qaqcSelections.historicArtifact = qaqcService.qaqcSelections().historicArtifact
                // }
                return this.qaqcProgressDto.qaqcSelections.historicArtifact
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Historic Artifact Form', message)
        },
        loadData () {
            var crrId = this.crrId
            this.log('Searching for assemblage for crr: ' + crrId)
            return historicArtifactService.search(this.$http, {culturalResourceRecordingId: crrId}).then(result => {
                if (result.data.length > 0) {
                    this.assemblageDto = result.data[0]
                    this.selectedList = this.assemblageDto.assemblageDetailsList.map(x => {
                        return x.artifactId
                    })
                    this.log('Found one assemblage: ' + this.assemblageDto.keywords)
                    this.$refs.ageSelection.setSelection(this.assemblageDto.significantPeriodList)
                    // load inventory items
                    this.inventoryList = []
                    this.assemblageDto.historicArtifactInventoryList.forEach(item => {
                        this.inventoryList.push(item)
                    })
                } else {
                    this.assemblageDto.culturalResourceRecordingId = crrId
                    this.createInventoryDto()
                    this.log('Nothing found')
                }
                return result
            })
        },
        loadLookups () {
            artifactService.listArtifact(this.$http).then(result => {
                this.artifactList = result.data.filter(x => {
                    return x.timePeriodId === 3
                })
                artifactService.listArtifactCategory(this.$http).then(result => {
                    this.artifactCategoryList = result.data.filter(x => {
                        return (x.artifactCategoryId >= 7 && x.artifactCategoryId <= 11)
                    })
                    return
                })
            })
        },
        createInventoryDto () {
            this.inventoryDto = {
                artifactType: '',
                collected: false
            }
        },
        inventoryDone () {
            this.inventoryList.push(this.inventoryDto)
            this.createInventoryDto()
            this.$refs.inventoryModal.close()
        },
        inventoryMore () {
            //TODO validation
            this.inventoryList.push(this.inventoryDto)
            this.createInventoryDto()
        },
        saveHistoricArtifact () {
            this.$validator.validateAll('historicArtifact').then(x => {
                this.assemblageDto.assemblageDetailsList = this.selectedList.map(x => {
                    return {
                        parentId: this.assemblageDto.historicArtifactAssemblageId || 0,
                        typeId: 3,
                        artifactId: x
                    }
                })
                this.assemblageDto.historicArtifactInventoryList = this.inventoryList.map(x => {
                    x.historicArtifactAssemblageId = this.assemblageDto.historicArtifactAssemblageId || 0
                    return x
                })
                var ageList = this.$refs.ageSelection.ageList.filter(x => { return x.isSelected })
                this.assemblageDto.significantPeriodList = ageList.map(x => {
                    x.significantPeriodId = x.selectId
                    x.historicArtifactAssemblageId = this.assemblageDto.historicArtifactAssemblageId || 0
                    return x
                })
                historicArtifactService.put(this.$http, this.assemblageDto).then(result => {
                    this.loadData()
                })
            })
        },
        removeInventory (index) {
            this.inventoryList.splice(index, 1)
        },
        completeSection (sectionName) {
            // check if all selections have been made
            if (Object.values(this.qaqcSelection).includes(0)) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.saveHistoricArtifact()
            this.saveQaqcProgress(sectionName, true)
        }
    }
}
</script>

<style>
.inline-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.inline-input {
  display: flex;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// HistoricArtifactForm.vue?4a4863de